module.exports = __webpack_public_path__ + "static/media/icon_recency-data-issue.de27fb73.svg";